<template>
  <v-app id="inspire">
    <div class="fill-height">
      <Header
        class="sheet"
        @toggleNavigationBar="toggleNavigationBar"
        v-show="!isPartnerLevel"
      ></Header>
      <release-notes-dialog ref="rn" />
      <Navigation
        v-if="isLoggedIn && !isPartnerLevel && !isadminLevel"
        class="blue-layout"
        :toggle="drawer"
      ></Navigation>
      <HeaderPartner v-show="isPartnerLevel"></HeaderPartner>
      <PartnerHubNavigation v-show="isPartnerLevel"></PartnerHubNavigation>
      <slideout-panel></slideout-panel>
      <v-main v-if="!isPartnerLevel" class="content-area">
        <slot />
      </v-main>
      <v-main v-else-if="isPartnerLevel" class="pa-0">
        <slot />
      </v-main>
      <Footer></Footer>
      <div v-if="isPopupVisible" class="popup-backdrop"></div>
    </div>
  </v-app>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import Header from '@/components/Header';
import Navigation from '@/components/Navigation';
import PartnerHubNavigation from '@/components/PartnerHubNavigation';
import HeaderPartner from '@/components/HeaderPartner';
import Footer from '@/components/Footer';
import ReleaseNotesDialog from '@/components/ReleaseNotesDialog.vue';

export default {
  name: 'LayoutBasic',
  components: {
    Header,
    Navigation,
    PartnerHubNavigation,
    Footer,
    Breadcrumb,
    HeaderPartner,
    ReleaseNotesDialog,
  },
  data() {
    return {
      drawer: screen.width > 700 ? true : false,
    };
  },
  methods: {
    toggleNavigationBar() {
      this.drawer = !this.drawer;
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isadminLevel() {
      return this.$store.getters.level === 1;
    },
    isPartnerLevel() {
      return this.$store.getters.level === 4 || this.$store.getters.level === 5;
    },
    isPopupVisible() {
      return this.$store.getters.bookDemo;
    }
  },
};
</script>

<style media="screen">
.basic-layout {
  padding-bottom: 32px;
}
.v-application .blue-layout .v-toolbar.primary {
  background-color: #3497c5 !important;
  border-color: #3497c5 !important;
}
.content-area{
  padding-top: 0px !important;
}
</style>
